export const SMALL_SCREEN_HEIGHT_THRESHOLD = 900;
export const SMALL_SCREEN_WIDTH_THRESHOLD = 500;
export const FULL_PAGE_Z_INDEX = 2147483647;
